import type { TraceStep } from "../types/result";

export class TraceRecorder {
  readonly steps: TraceStep[] = [];
  private n = 0;
  add(step: Omit<TraceStep, "id"> & { id?: string }): void {
    this.n += 1;
    const id = step.id ?? `step-${this.n}`;
    this.steps.push({ ...step, id });
  }
}
